module.exports = __webpack_public_path__ + "fonts/CabinetGrotesk-Extralight.5a3599b7.woff";